var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clinicList',{attrs:{"canEdit":_vm.check_has_permission('updateClinicManagement'),"editRoute":"AdminClinicEdit","canCreate":true,"createRoute":"AdminClinicCreate","canViewDetail":_vm.check_has_permission('viewClinicManagement'),"viewRoute":"AdminClinicDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }